<template>
  <div style="padding:1px;">
    <hd></hd>
    <div class="contioner">
        <h1>公司</h1>
        <div class="content">
            <h2>关于我们</h2>
            <p>JoyOrders隶属于上海悦单网络科技有限公司，提供海淘代下单服务，这里汇集了一批熟悉海淘的买手，帮您解决支付方式/语言不通/转运繁琐等下单障碍，开启轻松的跨境购物体验。</p>
        </div>
        <div class="content">
            <h2>人才招聘</h2>
            <p>我们是一个热爱互联网的年轻团队，致力于打造轻松的海淘C2C电子商务平台。目前正在招募海淘平台运营,客服,前端工程师、测试工程师，欢迎各位英才发送简历至邮箱：<a>cs@joyorders.com</a></p>
        </div>
        <div class="content">
            <h2>合作洽谈</h2>
            <h3>转运公司</h3>
            <p>欢迎转运公司和海外商家等潜在合作伙伴与JoyOrders 一起为海淘用户合作共赢，联系邮箱：<a>cs@joyorders.com</a></p>
            <h3>媒体联系</h3>
            <p>媒体问询, 请联系：<a>cs@joyorders.com</a></p>
        </div>
    </div>
    <mobilefooter v-if="mobiletype"></mobilefooter>
    <ft v-else class="ft"></ft>
    <GlobalDialogs></GlobalDialogs>
  </div>
</template>
<script>
import hd from '../../components/Header'
import ft from '../../components/Footer'
import api from '../../services/api.js'
import mobilefooter from '../../components/mobilefooter'
import Loading from '../../components/Loading'
import GlobalDialogs from '../../components/GlobalDialogs'
let _ = require('lodash')
let $ = require('jQuery')
export default {
    name: 'HelpCenter',
    components: {
      hd: hd,
      ft: ft,
      mobilefooter: mobilefooter,
      Loading: Loading,
    GlobalDialogs: GlobalDialogs
    },
    data() {
        return {
            screenWidth: document.body.clientWidth,
            mobiletype: false,
            
        }
    },
    created() {
        if (document.body.clientWidth < 1024) {
          this.mobiletype = true
        }
        
    },
    mounted() {
      const that = this
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth
          that.screenWidth = window.screenWidth
        })()

      }
    },
    methods: {
        
    },
    watch: {
        screenWidth (val) {
          if (!this.timer) {
            this.screenWidth = val
            console.log(val)
            if (val < 1024) {
              this.mobiletype = true
            }
            else {
              this.mobiletype = false
            }
            this.timer = true
            let that = this
            setTimeout(function () {
              // that.screenWidth = tha t.$store.state.canvasWidth
              that.timer = false
            }, 400)
          }
        }
        
      }
}
</script>
<style scoped lang="scss">
.contioner {
    margin: 0 auto 60px;;
    padding-left: 15%;
    padding-right: 15%;
    padding-top: 96px;
    min-height: 400px;
    border-bottom: 1px solid #cacaca;

    h1 {
        font-size: 1.875em;
        line-height: 1.2;
        color: #333333;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .content {
        border-top: 1px solid #cacaca;
        padding: 20px 0;

        h2 {
            line-height: 1.2;
            font-size: 1.875em;
            margin-bottom: 20px;
        }

        h3 {
            color: #737373;
            font-size: 1.375em;
            line-height: 1.2;
            margin-bottom: 20px;
        }

        p {
            color: #2f2f2f;
            line-height: 1.375;
            margin-bottom: 20px;
        }

        .button {
            background-color: #000 !important;
            color: #fff !important;
            width: 200px;
            height: 50px;
            margin-bottom: 20px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/company/company.vue